/* sg-why-us: al entrar en pantalla, las cifras cuentan desde 0 y las líneas se dibujan. */
if (!customElements.get('sg-why-us')) {
  class SgWhyUs extends HTMLElement {
    connectedCallback() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;

      this.counts = Array.from(this.querySelectorAll('.sg-wy__count'));
      this.counts.forEach((el) => { el.textContent = '0'; });
      this.classList.add('is-armed');

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.observer.disconnect();
        this.classList.add('is-in');
        this.counts.forEach((el, i) => this.animate(el, i * 100));
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    animate(el, delay) {
      const to = parseInt(el.dataset.to, 10) || 0;
      const duration = 1400;
      const start = performance.now() + delay;
      const tick = (now) => {
        const t = Math.min(1, Math.max(0, (now - start) / duration));
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = String(Math.round(to * eased));
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }
  customElements.define('sg-why-us', SgWhyUs);
}
